import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-ivory/20 py-4 shadow-inner">
      <div className="texture-toile absolute inset-0" aria-hidden="true" />
      <div className="absolute inset-0 bg-bordeaux/80" aria-hidden="true" />
      <div className="marquee-track relative flex w-max items-center whitespace-nowrap">
        {items.map((txt, i) => (
          <span
            key={i}
            className="flex items-center gap-10 pr-10 font-display text-sm font-medium uppercase tracking-[0.28em] text-ivory"
          >
            {txt}
            <span className="text-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
